import moment from 'moment'
import { clamp, merge } from 'lodash'
import { TAX, DELIVERY_FEE, CONTAINER_FEE } from '@/config'

// initial state
const state = {
  delivery: {
    address: { name: '', place_id: '' },
    date: undefined,
    hour: 0
  },
  chef: null,
  items: [],
  paymentMethod: null
}

// getters
const getters = {
  cartConfig: () => {
    return { maxCheckoutQuantity: 15 }
  },

  deliverOn: ({ delivery }) => moment(delivery.date).hour(delivery.hour),

  cartSize: ({ items }) => items.reduce((acc, cur) => acc + cur.quantity, 0),

  deliveryFee: () => DELIVERY_FEE,

  containerFeeSummary: ({ items }) =>
    items.reduce((acc, cur) => acc + CONTAINER_FEE * cur.quantity, 0),

  subTotal: ({ items }) =>
    items.reduce((acc, cur) => acc + cur.price * cur.quantity, 0),

  salesTax: (_, { containerFeeSummary, subTotal }) =>
    (containerFeeSummary + subTotal) * TAX,

  total: (_, { deliveryFee, containerFeeSummary, salesTax, subTotal }) =>
    deliveryFee + containerFeeSummary + salesTax + subTotal
}

// actions
const actions = {
  emptyCart({ commit }) {
    commit('setChef', null)
    commit('setItems', [])
    commit('setPaymentMethod', null)
  },

  addProductToCart({ state, commit, getters }, product) {
    if (product.left <= 0) return

    const item = state.items.find(x => x.id === product.id)

    // :total can not greator than 15
    let totalQuantity = 0
    state.items.map(product => (totalQuantity += product.quantity))

    const MAX_QUANTITY = getters.cartConfig.maxCheckoutQuantity
    if (totalQuantity >= MAX_QUANTITY) {
      return
    }

    if (!item) {
      commit('pushProductToCart', product)
    } else if (product.left - item.quantity) {
      commit('incrementItemQuantity', { id: product.id })
    }
  },

  decrementProductQuantity({ state, commit, dispatch }, product) {
    const item = state.items.find(x => x.id === product.id)

    if (!item) {
      // commit('pushProductToCart', product)
    } else if (product.left - item.quantity) {
      // commit('decrementItemQuantity', { id: product.id })
      return dispatch('changeProductQuantity', {
        product: item,
        quantity: item.quantity - 1
      })
    }
  },

  changeProductQuantity({ state, commit, dispatch }, { product, quantity }) {
    if (quantity <= 0) {
      return dispatch('removeProductFromCart', product)
    }

    commit('setItemQuantity', {
      id: product.id,
      quantity: clamp(quantity, product.left)
    })
  },

  removeProductFromCart: ({ state, commit }, product) => {
    const items = state.items.filter(x => x.id !== product.id)
    return commit('setItems', items)
  }
}

// mutations
const mutations = {
  setDelivery(state, delivery) {
    state.delivery = delivery
  },

  setDeliveryAddress(state, address) {
    state.delivery.address = address
  },

  setDeliveryDate(state, date) {
    state.delivery.date = date
  },

  setDeliveryHour(state, hour) {
    state.delivery.hour = hour
  },

  updateDelivery(state, delivery) {
    state.delivery = merge(state.delivery || {}, delivery)
  },

  setChef(state, chef) {
    state.chef = chef
  },

  setItems(state, items) {
    state.items = items
  },

  setPaymentMethod(state, paymentMethod) {
    state.paymentMethod = paymentMethod
  },

  pushProductToCart(state, product) {
    state.items.push({ ...product, quantity: 1 })
  },

  incrementItemQuantity(state, { id }) {
    const item = state.items.find(x => x.id === id)
    item.quantity++
  },

  decrementItemQuantity(state, { id }) {
    const item = state.items.find(x => x.id === id)
    item.quantity--
  },

  setItemQuantity(state, { id, quantity }) {
    const item = state.items.find(x => x.id === id)
    item.quantity = quantity
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
